import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getReportsShiftSummaries({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_REPORTS_SHIFT_SUMMARIES_REQUEST')
        
        return axios
            .get(`/reports/reports-shift-summaries${paginate}${query}`)
            .then(response => {
                commit('GET_REPORTS_SHIFT_SUMMARIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_REPORTS_SHIFT_SUMMARIES_FAILURE')
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportShiftSummary(context, id) {
        return axios
            .get(`/reports/reports-shift-summaries/${id}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do raportu zbiorczego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateReportShiftSummary({ commit }, reportShiftSummary) {
        return axios
            .put(`/reports/reports-shift-summaries/${reportShiftSummary.id}`, reportShiftSummary)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Raport został zatwierdzony.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Zatwierdzenie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDetailedReports({ commit }, {
        reportShiftSummary_id = null,
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_DETAILED_REPORTS_REQUEST')

        let uri = ''

        if (paginate || query) {
            uri = `/reports/reports-review${paginate}${query}&reportShiftSummary_id=${reportShiftSummary_id}`
        } else {
            uri = `/reports/reports-review?reportShiftSummary_id=${reportShiftSummary_id}`
        }

        return axios
            .get(uri)
            .then(response => {
                commit('GET_DETAILED_REPORTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DETAILED_REPORTS_FAILURE')
                handleApiError(error, 'Pobranie listy raportów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getSimpleReports(context, {
        paginate = '',
        query = ''
    } = {}) {

        return axios
            .get(`/reports/simple-reports${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy raportów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUserDetailedReports({ commit }, {
        reportShiftSummary_id = null,
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_USER_DETAILED_REPORTS_REQUEST')

        return axios
            .get(`/reports/reports${paginate}${query}&reportShiftSummary_id=${reportShiftSummary_id}`)
            .then(response => {
                commit('GET_USER_DETAILED_REPORTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_USER_DETAILED_REPORTS_FAILURE')
                handleApiError(error, 'Pobranie raportów  nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShipmentsReportsShiftSummaries({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_REQUEST')

        return axios
            .get(`/shipments/shipments-reports-shift-summaries${paginate}${query}`)
            .then(response => {
                commit('GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_FAILURE')
                handleApiError(error, 'Pobranie raportów zbiorczych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDetailedShipmentsReports({ commit }, {
        shipmentReportShiftSummary_id = null,
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_DETAILED_SHIPMENTS_REPORTS_REQUEST')

        let uri = '/shipments/shipments-reports'

        if (paginate || query) {
            uri += `${paginate}${query}&shipmentReportShiftSummary_id=${shipmentReportShiftSummary_id}`
        } else {
            uri += `?shipmentReportShiftSummary_id=${shipmentReportShiftSummary_id}`
        }

        return axios
            .get(uri)
            .then(response => {
                commit('GET_DETAILED_SHIPMENTS_REPORTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DETAILED_SHIPMENTS_REPORTS_FAILURE')
                handleApiError(error, 'Pobranie raportów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDetailedShipmentReport(context, id) {
        return axios
            .get(`/shipments/shipments-reports/${id}`)
            .then(response => {

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateShipmentReportShiftSummary({ commit }, shipmentReportShiftSummary) {
        return axios
            .put(`/shipments/shipments-reports-shift-summaries/${shipmentReportShiftSummary.id}`, shipmentReportShiftSummary)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Raport został zatwierdzony.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Zatwierdzenie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachines({ commit }) {
        commit('GET_MACHINES_REQUEST')

        return axios
            .get('/machines/machines')
            .then(response => {
                commit('GET_MACHINES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MACHINES_FAILURE')
                handleApiError(error, 'Pobranie informacji o maszynach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStatusNames({ commit }) {
        return axios
            .get('/reports/reports/dicts/report-statuses')
            .then(response => {
                commit('GET_STATUS_NAMES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie nazw statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getTaskNames({ commit }) {
        return axios
            .get('/reports/reports/dicts/report-object-types')
            .then(response => {
                commit('GET_OBJECT_TYPE_NAMES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie nazw zadań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getReportsShiftSummaryStatuses({ commit }) {
        return axios
            .get('/reports/reports/dicts/report-shift-summary-statuses')
            .then(response => {
                commit('GET_REPORT_SHIFT_SUMMARY_STATUSES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie nazw statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShipmentsReportsShiftSummaryStatuses({ commit }) {
        return axios
            .get('/shipments/shipments/dicts/shipment-report-shift-summary-statuses')
            .then(response => {
                commit('GET_SHIPMENTS_REPORT_SHIFT_SUMMARY_STATUSES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie nazw statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateReportShiftSummariesReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/reports-shift-summaries?${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateShipmentReportShiftSummariesReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/shipments/shipments-reports-shift-summaries?${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCodeCompliancesList({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        return axios
            .get(`/reports/code-compliances${paginate}${query}`)
            .then(response => {
                commit('GET_CODE_COMPLIANCE_PATTERNS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie wzorów zgodności kodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateCodeCompliancesListReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/code-compliances?report=true${query}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Po wygenerowaniu raport zostanie wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersOfJob(context, payload) {
        return axios
            .get(`/reports/report-items/orders-of-job?primaryNumber=${payload.primaryNumber}&plateNumber=${payload.plateNumber}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCompliance(context, payload) {
        return axios
            .post('/reports/code-compliances', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie wzoru zgodności kodu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addCompliancePattern(context, payload) {
        return axios
            .post('reports/code-compliance-patterns', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie kodu zgodności nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateReportItemPlates(context, payload) {
        return axios
            .patch(`reports/report-item-plates/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja raportu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getActiveReports(context, {
        paginate = '',
        query = ''
    } = {}) {
        return axios
            .get(`reports/active-reports${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie aktywnych raportów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPrinectAmount({ commit }, payload) {
        return axios
            .post('reports/prinect-amount', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Pobrano nakład z systemu Prinect.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie nakładu z prinecta nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPrinectMakeReadyAmount({ commit }, payload) {
        return axios
            .post('reports/prinect-make-ready-amount', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Pobrano sugerowany nakład z systemu Prinect.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie sugerowanego nakładu z prinecta nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reviewAdditionalAction({ commit }, payload) {
        return axios
            .put(`/reports/review-process-code-report/${payload.reportId}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zatwierdzanie czynności dodatkowej zostało zaktualizowane.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Zatwierdzanie czynności dodatkowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setDetailedReportsFilters({ commit }, filters) {
        commit('SET_DETAILED_REPORTS_FILTERS', filters)
    },
    clearDetailedReportsFilters({ commit }) {
        commit('CLEAR_DETAILED_REPORTS_FILTERS')
    },
    setReportsShiftSummariesFilters({ commit }, filters) {
        commit('SET_REPORTS_SHIFT_SUMMARIES_FILTERS', filters)
    },
    clearReportsShiftSummariesFilters({ commit }) {
        commit('CLEAR_REPORTS_SHIFT_SUMMARIES_FILTERS')
    },
    setUserReportsShiftSummariesFilters({ commit }, filters) {
        commit('SET_USER_REPORTS_SHIFT_SUMMARIES_FILTERS', filters)
    },
    clearUserReportsShiftSummariesFilters({ commit }) {
        commit('CLEAR_USER_REPORTS_SHIFT_SUMMARIES_FILTERS')
    },
    clearReportsShiftSummaries({ commit }) {
        commit('CLEAR_REPORTS_SHIFT_SUMMARIES')
    },
    setDetailedShipmentsReportsFilters({ commit }, filters) {
        commit('SET_DETAILED_SHIPMENTS_REPORTS_FILTERS', filters)
    },
    clearDetailedShipmentsReportsFilters({ commit }) {
        commit('CLEAR_DETAILED_SHIPMENTS_REPORTS_FILTERS')
    },
    setReportsShiftSummaryRedirectionSource({ commit }, boolean) {
        commit('SET_FROM_MACHINE_DASHBOARD_REDIRECT', boolean)
    },
    clearCodeCompliancesFilters({ commit }) {
        commit('CLEAR_CODE_COMPLIANCES_FILTERS')
    }
}